import FlyingBirdGame from './FlyingBirdGame.tsx';
export default FlyingBirdGame;
